<template>
  <div>
    <Main
      ref="main"
      :loading="loading"
      :tableData="tableData"
      :tablePage="page"
      @reload="close()"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        :disabled="disabled"
      >
        <b-button
          size="sm"
          class="ml-2"
          variant="outline-primary"
          v-if="!disabled && allow('A')"
          @click="showAddReview = true"
        >
          {{ $l('btn_review') || '审核意见' }}
        </b-button>
      </PageHeader>
    </Main>
    <AddReview
      :amzFirstDemandCode="amzFirstDemandCode"
      @close="close"
      :visible="showAddReview"
    ></AddReview>
  </div>
</template>
<script>
import Main from './main.vue'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import AddReview from '../add-review'
export default {
  mixins: [BaseTable, EditLoading],
  components: { Main, PageHeader, AddReview },
  props: {
    disabled: { type: Boolean, default: false },
    amzFirstDemandCode: { type: String, default: '' },
    isVcList: { type: Array, default: () => [] },
  },
  data() {
    return {
      usePage: false,
      loading: false,
      showAddReview: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData(form) {
      if (!this.amzFirstDemandCode) return
      this.loading = true
      const res = await this.$api
        .ecomAmzFirstDemandReviewListApi({
          amzFirstDemandCode: this.amzFirstDemandCode,
          ...form,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.setData(res)
    },

    close() {
      this.showAddReview = false
      this.getData()
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  height: 20px;
  margin-top: 3px;
}
.tag_div {
  border: 1px solid #dcdfe6;
  padding: 0px 7px 7px 7px;
  border-radius: 4px;
  min-height: 50px;
}
</style>
